<div class="workflow-section">
  <div class="workflow-heading-wrapper">
    <p class="workflow-label">Beyond the Pipeline</p>
    <h2 class="workflow-heading">Activities, Marketing &amp; Services — Together</h2>
    <p class="workflow-subtitle">
      The work that happens around a deal matters just as much as the deal itself.
    </p>
  </div>

  <div class="workflow-shell">

    <!-- Activities: schedule widget -->
    <div class="workflow-card workflow-card--activities">
      <div class="workflow-card-header">
        <span class="workflow-icon">🗓️</span>
        <h3>Activities</h3>
      </div>
      <p class="workflow-desc">Calls, meetings, and follow-ups — scheduled and logged against the right contact or deal.</p>

      <div class="widget-schedule">
        <div class="schedule-row" *ngFor="let item of schedule">
          <span class="schedule-time">{{ item.time }}</span>
          <span class="schedule-label">{{ item.label }}</span>
        </div>
      </div>
    </div>

    <!-- Marketing: stat widget -->
    <div class="workflow-card workflow-card--marketing">
      <div class="workflow-card-header">
        <span class="workflow-icon">📣</span>
        <h3>Marketing</h3>
      </div>
      <p class="workflow-desc">Send campaigns to the right list, and see straight away which ones turned into real conversations.</p>

      <div class="widget-stats">
        <div class="stat-item" *ngFor="let stat of campaignStats">
          <span class="stat-value">{{ stat.value }}</span>
          <span class="stat-label">{{ stat.label }}</span>
        </div>
      </div>
    </div>

    <!-- Services: ticket widget -->
    <div class="workflow-card workflow-card--services">
      <div class="workflow-card-header">
        <span class="workflow-icon">🛠️</span>
        <h3>Services</h3>
      </div>
      <p class="workflow-desc">When a customer needs help after the sale, log it as a case and track it through to resolution.</p>

      <div class="widget-tickets">
        <div class="ticket-row" *ngFor="let ticket of tickets">
          <span class="ticket-id">{{ ticket.id }}</span>
          <span class="ticket-label">{{ ticket.label }}</span>
          <span class="ticket-status" [ngClass]="ticket.statusClass">{{ ticket.status }}</span>
        </div>
      </div>
    </div>

  </div>
</div>
